import { useDispatch } from 'react-redux';
import { ACCESS_TOKEN, SERVERKNOWNSALT, USER_DETAILS, USER_ID } from '../common/constants';
import { removeauthInfo, resetAuth } from '../common/features/auth/AuthActions';
import { logoutCustomer } from '../common/features/auth/AuthAPI';
import { useNavigate } from 'react-router';
import {
  removeCartItemOrderType,
  resetCart,
  startEmptyCart,
  clearDeliveryInstruction,
} from '../common/features/cart/cartActions';
import { clearGetDeliveryCharge, resetDelivery } from '../common/features/delivery/DeliveryActions';
import {
  removeDeliveryAddress,
  resetRestaurant,
} from '../common/features/restaurant/restaurantAction';
import { removeCardDetails, resetPayment } from '../common/features/payment/PaymentActions';
import { resetCheckIn } from '../common/features/checkIn/checkInActions';
import { resetOffer } from '../common/features/offers/offerActions';
import { resetLoyalty } from '../common/features/loyalty/loyaltyActions';
import { useSelector } from 'react-redux';
import { storeSelectedIngredientChecklist, storeToggleStatus } from '../common/features/restaurant/restaurantAction';
import { logoutUserDetailsSuccess } from '../common/features/user/userActions';
import { deleteCookie, getCookie } from '../helper/cookieHelper';
import { getTokenCookie } from '../helper/getTokenCookie';

const useAuth = (params?: any) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const rawData = localStorage.getItem('restaurant');
  const slugFromLocalStorage = rawData ? JSON.parse(rawData) : {};
  const isExploretabActive = useSelector((state: any) => state.restaurant.isExploretabActive)

  const handleLogout = async (routeTo: string = 'menu') => {
    const tokenFromCookie = getCookie(ACCESS_TOKEN);
    const tokenFromLocalStorage = localStorage.getItem(ACCESS_TOKEN);
    const tokenFromRawCookie = getTokenCookie();
    const accessToken =
      (typeof tokenFromCookie === 'string' && tokenFromCookie) ||
      tokenFromLocalStorage ||
      tokenFromRawCookie ||
      undefined;

    try {
      await logoutCustomer(accessToken);
    } catch (error) {
      console.error('Logout API failed:', error);
    }

    deleteCookie(USER_ID);
    deleteCookie(USER_DETAILS);
    deleteCookie(ACCESS_TOKEN);
    deleteCookie(SERVERKNOWNSALT);
    sessionStorage.clear();

    dispatch(removeauthInfo());
    dispatch(logoutUserDetailsSuccess(false));
    dispatch(resetAuth());
    dispatch(resetCheckIn());
    dispatch(resetDelivery());
    dispatch(resetOffer());
    dispatch(resetPayment());
    dispatch(resetRestaurant());
    dispatch(resetCart());
    dispatch(resetLoyalty());
    dispatch(clearDeliveryInstruction());
    dispatch(clearGetDeliveryCharge());
    dispatch(removeDeliveryAddress());
    dispatch(removeCardDetails());
    dispatch(
      storeToggleStatus({
        onlyAvailable: true,
        nonVegetarian: false,
        vegetarian: false,
      })
    );
    dispatch(storeSelectedIngredientChecklist([]));
    dispatch(
      startEmptyCart({
        menuType: slugFromLocalStorage?.menuType,
        restaurantSlug: slugFromLocalStorage?.location,
        clearCartItems: true,
        merchantType: '',
      })
    );
    dispatch(removeCartItemOrderType());
    if(isExploretabActive){
      navigate(
        `/${slugFromLocalStorage?.merchantType}/${slugFromLocalStorage?.location}/menu/${slugFromLocalStorage?.menuType}/exploremenu`
      );
    }else{
      switch (routeTo) {
      case 'menu':
        navigate(
          `/${slugFromLocalStorage?.merchantType}/${slugFromLocalStorage?.location}/menu/${slugFromLocalStorage?.menuType}`
        );
        break;
      case 'noRedirect':
        break;
      default:
        navigate(
          `/${slugFromLocalStorage?.merchantType}/${slugFromLocalStorage?.location}/menu/${slugFromLocalStorage?.menuType}`
        );
        break;
    }
    }
  };

  return {
    handleLogout,
  };
};

export default useAuth;
